// Central place for external / cross-application links used across the site.
//
// X7 PM (the internal Project Management, CRM & Payroll platform) is deployed
// on the SAME domain under the /pm path:
//
//     https://x7ittechnologies.com/pm/
//
// Nginx serves the X7 PM build from /pm/ and proxies /api/ to its FastAPI
// backend (see x7pm/deploy/nginx/x7-combined.conf). A same-origin path is used
// rather than a full URL so the link keeps working on staging/preview domains.
//
// Override with REACT_APP_X7PM_URL in .env — useful for local development,
// where X7 PM runs on its own Vite dev server.
//
// NOTE: Create React App only exposes env vars prefixed with REACT_APP_, and
// reads them at BUILD time — restart `npm start` / re-run `npm run build`
// after changing .env.

export const X7PM_URL = process.env.REACT_APP_X7PM_URL || "/pm/";

export default { X7PM_URL };
